import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AppSettings } from 'pac-api';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { empty } from '../helpers';
import { LoggerService } from '../logger.service';
import { Individual } from '../model/individual';
import { WizardStep } from '../wizard-step';
import { WizardNavigationService } from '../wizard/wizard-navigation.service';
import { WizardService } from '../wizard/wizard.service';
import { ValidateEmailResponseCode } from './validate-email-response';
import { ValidateService } from './validate.service';


@Component({
  selector: 'app-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})
export class EmailComponent implements OnInit, WizardStep {

  static readonly Name = 'EmailComponent';
  readonly Name = 'EmailComponent';

  private _isSaving: boolean;

  ResponseCode = ValidateEmailResponseCode;
  individual: Individual;
  form: UntypedFormGroup;

  public loginDestination = this.route.snapshot.data.destination ?? 'members/renew';

  public get isSaving(): boolean {
    return this._isSaving;
  }

  public set isSaving(value: boolean) {
    this._isSaving = value;
    this.app.wait(value);
  }

  get eml_address(): AbstractControl {
    return this.form.get('eml_address');
  }

  public HasError: Observable<boolean>;

  public HasSuccess: Observable<boolean>;

  constructor(
    private wizard: WizardService,
    private navigation: WizardNavigationService,
    private validate: ValidateService,
    private route: ActivatedRoute,
    private logger: LoggerService,
    private changeDetector: ChangeDetectorRef,
    private app: AppComponent,
    public settings: AppSettings,
  ) {
    this.isSaving = false;
  }

  public ngOnInit(): void {
    this.route.queryParamMap.subscribe(query => {
      if(query.has('destination')) {
        this.loginDestination = query.get('destination');
      } else if (query.has('affinity')) {
        this.loginDestination = '/signup/AffinityPortal/' + query.get('affinity') + '/select';
      }

      this.individual = new Individual(this.wizard.getIndividual());

      this.form = new UntypedFormGroup({
        eml_address : new UntypedFormControl(this.individual.eml_address, [ Validators.required, Validators.email ])
      });

      if (empty(this.individual.eml_address) && query.has('email')) {
        this.eml_address.setValue(query.get('email'));
        this.eml_address.markAsDirty();
        this.OnSubmit();
      }
    });

    this.HasError = this.eml_address.statusChanges.pipe(
      map(status => status === 'INVALID' && (this.eml_address.dirty || this.eml_address.touched)),
      shareReplay(1),
    );

    this.HasSuccess = this.eml_address.statusChanges.pipe(
      map(status => status === 'VALID'  && (this.eml_address.dirty || this.eml_address.touched)),
      shareReplay(1),
    );
  }

  public ready(): boolean {
    return true;
  }

  public OnSubmit(): void {
    this.individual.eml_address = this.form.value.eml_address;

    this.isSaving = true;

    this.changeDetector.detectChanges();

    this.validate.email(this.individual).subscribe(result => {
      if (result.status) {
        this.wizard.setIndiviudal(this.individual);
        this.navigation.next(this, this.route);
      } else {
        this.eml_address.setErrors({ emailValidator: result });
        this.isSaving = false;
      }
    }, error => {
      try {
        this.logger.log(error);
      } catch {}

    });
  }
}
